import React, { useEffect } from "react";
import "./OurServices2.css";
import Maro from "../images/Maros.jpg";
import CSGO from "../images/kiosk.png";
import ECommerce from "../images/online_shop.PNG";
import Doumicom from "../images/doumicomlogo.png";

const OurServices2 = () => {
  const customers = [
    { id: 1, name: "Doumicom Group", image: Doumicom },
    { id: 2, name: "Maro's Pizza", image: Maro },
    { id: 3, name: "CSGO", image: CSGO },
    { id: 4, name: "E-Commerce", image: ECommerce },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll(".ourservices2-container .animate-side");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="ourservices2-container">
      <h1 className="animate-side slide-left">Our Customers</h1>

      <div className="customers-grid">
        {customers.map((customer, index) => {
          const slideDirection = index % 2 === 0 ? "slide-left" : "slide-right";

          return (
            <div
              key={customer.id}
              className={`customer-card animate-side ${slideDirection}`}
            >
              <img src={customer.image} alt={customer.name} />
              <p>{customer.name}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OurServices2;